import Vue from "vue";
import { extend, localize } from "vee-validate";
import * as rules from 'vee-validate/dist/rules';
import es from "vee-validate/dist/locale/es.json";
import en from "vee-validate/dist/locale/en.json";

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});

extend('confirmed_ci', {
    params: ['target'],
    validate(value, { target }) {
        return value.toLowerCase() == target.toLowerCase();
    },
    message: es.messages.confirmed,
});

localize({
    en: {
        messages: en.messages
    },
    es: {
        messages: es.messages
    }
});

let LOCALE = "es";

// A simple get/set interface to manage our locale in components.
// This is not reactive, so don't create any computed properties/watchers off it.
Object.defineProperty(Vue.prototype, "locale", {
    get() {
        return LOCALE;
    },
    set(val) {
        LOCALE = val;
        localize(val);
    }
});